import { AlertComponent } from './Alert.component';
import { ContratoModel } from './model/ContratoModel';
import { ContratoMenuModel } from './model/ContratoMenuModel';
import { AlertButton } from '@ionic/core';
import { BasePage } from 'src/pages/base.page';
import { ContratoWrapperModel } from './model/ContratoWrapperModel';
import { NavegaTelaPlanoImpl } from 'src/pages/plano-ios/NavegaTelaPlanoImpl';
import { AppSession } from './AppSession';
import { AppStorage } from './AppStorage';

export class HelperMenuContrato {

  constructor() {}

  static async validaMenu(item: ContratoMenuModel) {

    const contratoWrapper = await AppStorage.get(AppSession.CHAVE_CONTRATO_USUARIO)

    if (!item.active) {
      AlertComponent.showAlert("Olá", 'Funcionalidade não disponível no momento. Aguarde novidades!')
      return false;
    }

    let listaBotoesDialog = HelperMenuContrato.retornaBotoesDialogFuncionalidade(contratoWrapper)

    if (!ContratoModel.verificaMenuLiberadoPorContrato(item, contratoWrapper.contratos)) {
      HelperMenuContrato.navegaTelaPlanos(contratoWrapper.url_contratar)
      return false;
    }

    if (ContratoModel.verificaContratoProximoExpirar(item, contratoWrapper.contratos)) {
      AlertComponent.showAlert("Olá", 'Seu plano vence dentro de ' + ContratoModel.QUANTIDADE_DIAS_AVISO_EXPIRACAO + ' dias. Acesse o menu de planos e contrate agora!', null, listaBotoesDialog)
    }

    return true;
  }

  static navegaTelaPlanos(urlContratar) {
    NavegaTelaPlanoImpl.navegaTelaPlano(urlContratar)
  }

  private static retornaBotoesDialogFuncionalidade(contratoWrapper: ContratoWrapperModel): Array<AlertButton> {
    let botoesDialog: Array<AlertButton> = [{
      text: 'Cancelar',
      role: 'cancelar'
    }]

    if (contratoWrapper.compra_liberada) {
      botoesDialog.push({
        text: 'Continuar',
        role: 'continuar',
        handler: () => {
          BasePage.openPage('contratacao')
        }
      })
    }
    return botoesDialog
  }
}